/**
 * Spanish translation for bootstrap-datepicker
 * Bruno Bonamin <bruno.bonamin@gmail.com>
 */
(function () {
  Datepicker.locales.es = {
    days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    today: "Hoy",
    monthsTitle: "Meses",
    clear: "Borrar",
    weekStart: 1,
    format: "dd/mm/yyyy"
  };
})();
const langDropdown = document.getElementById("lang-dropdown");
if (langDropdown) {
  langDropdown.querySelector(".lang-dropdown__active").addEventListener("click", () => {
    console.log("hola");
    langDropdown.classList.toggle("open");
  });
  document.querySelector(".lang-dropdown__current").addEventListener("click", () => {
    document.querySelector(".lang-dropdown__content").classList.add("open");
  });
  document.querySelector(".lang-dropdown__overlay").addEventListener("click", () => {
    document.querySelector(".lang-dropdown__content").classList.remove("open");
  });
}
const autocompleteInput = document.querySelectorAll(".autocomplete");
if (autocompleteInput) {
  for (let c = 0; c < autocompleteInput.length; c++) {
    const list = autocompleteInput[c].dataset.list;
    const autoCompleteJS = new autoComplete({
      selector: `#${autocompleteInput[c].id}`,
      data: {
        src: window[list],
        cache: true
      },
      resultItem: {
        highlight: true
      },
      events: {
        input: {
          selection: event => {
            const selection = event.detail.selection.value;
            autoCompleteJS.input.value = selection;
          }
        }
      }
    });
  }
}
const dateElem = document.querySelectorAll('input[class="datepicker"]');
if (dateElem) {
  for (let d = 0; d < dateElem.length; d++) {
    const datepicker = new Datepicker(dateElem[d], {
      language: "es",
      autohide: true
    });
  }
}
const selectEl = document.querySelectorAll("select");
if (selectEl) {
  for (let s = 0; s < selectEl.length; s++) {
    selectEl[s].addEventListener("change", () => {
      const selectValue = selectEl[s].value;
      if (selectValue !== "") {
        selectEl[s].classList.add("selected");
      } else {
        selectEl[s].classList.remove("selected");
      }
    });
  }
}
const hasVisa = document.querySelectorAll('input[name="has_visa"]');
if (hasVisa) {
  for (let s = 0; s < hasVisa.length; s++) {
    hasVisa[s].addEventListener("change", () => {
      console.log(hasVisa[s].value);
      if (hasVisa[s].value === "yes") {
        document.getElementById("has-visa-fields").style.display = "block";
      } else {
        document.getElementById("has-visa-fields").style.display = "none";
      }
    });
  }
}
const flightType = document.querySelectorAll('input[name="flight_type"]');
if (flightType) {
  for (let s = 0; s < flightType.length; s++) {
    flightType[s].addEventListener("change", () => {
      console.log(flightType[s].value);
      if (flightType[s].value === "commercial") {
        document.getElementById("airline-fields").style.display = "block";
      } else {
        document.getElementById("airline-fields").style.display = "none";
      }
    });
  }
}
const benefitsBtn = document.getElementById("open-benefits");
if (benefitsBtn) {
  benefitsBtn.addEventListener("click", () => {
    document.querySelector(".home-intro__benefits").classList.toggle("mobile-visible");
    if (document.querySelector(".home-intro__benefits").classList.contains("mobile-visible")) {
      benefitsBtn.innerHTML = "Ocultar Beneficios";
    } else {
      benefitsBtn.innerHTML = "Ver Beneficios";
    }
  });
}
const openLoader = () => {
  document.getElementById("loader").classList.add("open");
};
const closeLoader = () => {
  document.getElementById("loader").classList.remove("open");
};